<template>
  <div v-if="mostrarAgravos" class="vx-row mb-6">
    <div
      v-for="(item, index) in listAgravos"
      :key="index"
      class="vx-col w-full lg:w-1/3 mt-6"
    >
      <label :for="item.pergunta" class="vs-select--label">{{
        item.pergunta
      }}</label>
      <v-select
        :options="item.respostas"
        :name="item.pergunta"
        :id="item.pergunta"
        v-model="agravos[index][item.pergunta]"
        v-validate="{ required: true }"
        label="resposta"
        placeholder="Selecione"
        :state="validateState(veeFields, veeErrors, item.pergunta)"
        :class="validateStateClass(veeFields, veeErrors, item.pergunta)"
      ></v-select>
    </div>
  </div>
</template>
<script>
import utilsList from '../../../utils/list';
import functions from '../../../utils/functions';
import vSelect from 'vue-select';

export default {
  name: 'agravos-form',
  components: {
    vSelect,
  },
  props: ['listAgravos', 'formData', 'idGrupo', 'parent'],
  data() {
    return {
      mostrarAgravos: false,
      agravos: [],
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      oldValue: null,
    };
  },
  created() {
    this.atribuirValidatorAncestral();
  },
  mounted() {
    this.atribuirAgravos();
  },
  methods: {
    atribuirValidatorAncestral() {
      this.$validator = functions.buscarValidatorAncestral(
        this.$validator,
        this.$parent,
        this.parent,
      );
    },
    atribuirAgravos() {
      if (!this.formData.agravos) {

        return;
      }

      this.agravos = this.formData.agravos;

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.agravos = this.agravos;

      this.mostrarAgravos = true;
    },
  },
};
</script>
<style></style>
